/*
 * 校验数字(整数)
 * */
export const checkInt = (str)=>{
  if (!str)return str;
  return str.match(/\d/ig) ? str.match(/\d/ig).join('') : '';
}
